__webpack_require__.p = "/reports-resize-on-sidebar-changes/system-email-templates/";